import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { PassengersReportService } from '../../services/passengers-report.service';
import { CommonService } from '../../services/common.service' ;
import { PointsService} from '../../services/points.service';
import { ExcelService} from '../../services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { NgSelectOption } from '@angular/forms';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import swal from 'sweetalert2';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';

import { MatTableModule } from '@angular/material'  

import {MatSort} from '@angular/material/sort';
import { DriversService } from '../../services/drivers.service';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';
//declare var $: any;
var s='';
//declare var $ :any;
@Component({
  selector: 'app-time-report',
  templateUrl: './time-report.component.html',
  styleUrls: ['./time-report.component.css']
})
export class TimeReportComponent implements OnInit {
  platesBuffer = [];
  loading1 = false;
  bufferSize = 50;
  imeiVei: any= {};
  vehiculo: any= {};
  plates: any = [];
  user_account: any;
  dataObj: any = [];
  data: any = [];
  cols: any = [];
  checkingPoints: any = [];
  placas: any = [];
  report: any = [];
  reportAux: any = [];
  model: any = {};
  returnUrl: string;
  isSubmitted: any = false;
  dataReport: any = [];
  dataReport2: any = [];
  totalIn: any;
  totalOut: any;
  totalAfter: any;
  totalBefore: any;

  promTot: any;
  totalProm: any;
  dateNowInit: any;
  dateNowEnd: any;
  public loading = false;
  dIni: any;
  dFin: any;
  filterMenuVisible: boolean = false;
  displayedColumns: string[];

  selectedCity: any;
  controlPoints: any = [];

  platesSettings = {};
  selectedPlates = [];

  pointsSettings = {};
  selectedPoints = [];

  drivers = []
  driversSettings = {};
  selectedDrivers = [];

  totalMas = 0
  totalMenos = 0

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private vpcReportService: PassengersReportService,
    private pointsService: PointsService,
    private excelService: ExcelService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private driversService: DriversService,
    ) { }

  ngAfterViewInit(){
    $(".mat-paginator-page-size").css("display", "none")
  }

  ngOnInit() {
    
    var now = new Date(); //currentDate
    this.reportAux.dateIni = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
    this.reportAux.dateFin = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
    this.reportAux.timeIni = '00:00';
    this.reportAux.timeFin = '23:59';


    this.platesSettings = {
      singleSelection: false,
      idField: 'sn_imei_id',
      textField: 'tracker_name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.pointsSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
    this.getPlates();
    this.getCheckingType();
    this.getDrivers();
    
  }

  getDrivers(): void {

    this.driversSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.driversService.getDrivers_rol(this.commonService.getUserName())
      .then(response => {
        console.log(response)
        this.drivers = response
      });
  }
  
  getCheckingType():void{
    this.pointsService.getTypeCheckingPoint_rol(this.commonService.getUserName()).then(response => {
      if(response){
        this.checkingPoints = response;
        this.checkRepeatedControlPoints();


        this.selectedPoints = this.checkingPoints        
      }
    });
  }

  checkRepeatedControlPoints(){
    // Revisa si existe un punto de control con el mismo nombre
    for (let i = 0; i < this.checkingPoints.length; i++) {
      for (let j = 0; j < this.checkingPoints.length; j++) {
        
        if(this.checkingPoints[i].id != this.checkingPoints[j].id
          && this.checkingPoints[i].name == this.checkingPoints[j].name){
            this.checkingPoints[j].name = this.checkingPoints[j].name + "2"

        }
        
      }
      
    }
  }


  loadReport(): void {
    console.log(s);
    this.dataObj = [];
    var d1, m1, d2, m2;
    if (this.reportAux.dateIni.day < 10) {
        d1 = '0' + this.reportAux.dateIni.day;
    }else{
       d1 = this.reportAux.dateIni.day;
    }
    if (this.reportAux.dateIni.month < 10) {
       m1 = '0' + this.reportAux.dateIni.month;
    }else{
      m1 = this.reportAux.dateIni.month;
    }
    var dateIni = d1 + '-' + m1 + '-' + this.reportAux.dateIni.year + ' ' + this.reportAux.timeIni;

    if (this.reportAux.dateFin.day < 10) {
        d2 = '0' + this.reportAux.dateFin.day;
    }else{
        d2 = this.reportAux.dateFin.day;
    }
    if (this.reportAux.dateFin.month < 10) {
        m2 = '0' + this.reportAux.dateFin.month;
    }else{
        m2 = this.reportAux.dateFin.month;
    }
    var dateFin = d2 + '-' + m2 + '-' + this.reportAux.dateFin.year + ' ' + this.reportAux.timeFin;
    dateIni = dateIni.replace(':', '_');
    dateFin = dateFin.replace(':', '_');
    console.log('dateIni : ', dateIni);
    console.log('dateFin : ', dateFin);
    this.spinner.show();

    this.imeiVei = this.selectedPlates.map(({ sn_imei_id }) => "'" + sn_imei_id + "'").toString();
    var points = this.selectedPoints.map(({ id }) => "'" + id + "'").toString();
    var driversId = this.selectedDrivers.map(({ id }) => "'" + id + "'").toString();

    //if(this.imeiVei!=undefined){
        $('.tbodyTable').empty();
        //var dateIni = $('#dateIni').val().replace(':', '_');
        //var dateFin = $('#dateFin').val().replace(':', '_');
        if (dateIni && dateFin) {
          console.log('iniciando')
          this.vpcReportService.vpcReportTime_new(this.imeiVei, dateIni, dateFin, points, driversId)
            .then(data => {
              this.spinner.hide();
              this.controlPoints = this.checkingPoints
              //this.controlPoints = data.controlPoints
              
              
              for(var i in data.trips){
                // Limpia la fecha de inicio para usarla como id
                var id = data.trips[i].StartDate.replace(/[^0-9\.]+/g, '');
                data.trips[i].id = id
                data.trips[i].totalAfter = 0                
                data.trips[i].totalBefore = 0

                // Setea la fecha y las hroas
                data.trips[i].StartDate = new Date(data.trips[i].StartDate)
                data.trips[i].StartTime = data.trips[i].StartDate
                                                  .toLocaleString('es-CO', { hour12: true })
                                                  .split(",")[1]
                
                data.trips[i].EndingDate = new Date(data.trips[i].EndingDate)
                data.trips[i].EndingDate = data.trips[i].EndingDate
                                                      .toLocaleString('es-CO', { hour12: true })
                                                      .split(",")[1]

                data.trips[i].StartDate = data.trips[i].StartDate
                                                .toLocaleString('es-CO', { hour12: true })
                                                .split(",")[0]

                // Setea las cantidades 
                console.log(this.controlPoints)
                for(var j in this.controlPoints){
                  for(var k in data.trips[i].caidas){
                    var currentCaida = data.trips[i].caidas[k]
                    
                    if(this.controlPoints[j].id == currentCaida.ControlPointId){
                      data.trips[i][this.controlPoints[j].name] = currentCaida.diference
                      
                      // Setea la cantidad total
                      if(+currentCaida.diference < 0){
                        data.trips[i].totalBefore += currentCaida.diference
                        this.totalMenos += currentCaida.diference
                      }else{
                        data.trips[i].totalAfter += currentCaida.diference
                        this.totalMas += currentCaida.diference
                      }

                    }else if(data.trips[i][this.controlPoints[j].name] == undefined){// pasó a tiempo por el punto
                      data.trips[i][this.controlPoints[j].name] = 0
                    }

                  }

                  // La ruta no tiene caidas, le pone 0 en cada punto
                  if(data.trips[i].caidas.length == 0){
                    data.trips[i][this.controlPoints[j].name] = 0
                  }

                  
                }
                
              }
              this.setTable(data.trips, points)
              this.setExcelData(data.trips)
              console.log(data)
            })
            .catch(error => {
              console.log(error)
              this.spinner.hide();
                swal({
                title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
                text: '',
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              }).catch(swal.noop);
            });
        }else {
          this.spinner.hide();
          swal({
            title: 'Ingresa Todos los campos solicitados',
            text: '',
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#ff5370',
            confirmButtonText: 'Volver',
            // cancelButtonText: 'No'
          }).catch(swal.noop);
        }
     //}
  }

  

  // loadReportOld(): void {
  //   console.log(s);
  //   this.dataObj = [];
  //   console.log('this.imeiVei : ', this.imeiVei)
  //   console.log('fecha inicial :', this.reportAux.dateIni)
  //   var d1, m1, d2, m2;
  //   if (this.reportAux.dateIni.day < 10) {
  //       d1 = '0' + this.reportAux.dateIni.day;
  //   }else{
  //      d1 = this.reportAux.dateIni.day;
  //   }
  //   if (this.reportAux.dateIni.month < 10) {
  //      m1 = '0' + this.reportAux.dateIni.month;
  //   }else{
  //     m1 = this.reportAux.dateIni.month;
  //   }
  //   var dateIni = d1 + '-' + m1 + '-' + this.reportAux.dateIni.year + ' ' + this.reportAux.timeIni;

  //   if (this.reportAux.dateFin.day < 10) {
  //       d2 = '0' + this.reportAux.dateFin.day;
  //   }else{
  //       d2 = this.reportAux.dateFin.day;
  //   }
  //   if (this.reportAux.dateFin.month < 10) {
  //       m2 = '0' + this.reportAux.dateFin.month;
  //   }else{
  //       m2 = this.reportAux.dateFin.month;
  //   }
  //   var dateFin = d2 + '-' + m2 + '-' + this.reportAux.dateFin.year + ' ' + this.reportAux.timeFin;
  //   dateIni = dateIni.replace(':', '_');
  //   dateFin = dateFin.replace(':', '_');
  //   console.log(dateIni);
  //   console.log(dateFin);
  //   this.spinner.show();
  //   if(this.imeiVei!=undefined){
  //       $('.tbodyTable').empty();
  //       //var dateIni = $('#dateIni').val().replace(':', '_');
  //       //var dateFin = $('#dateFin').val().replace(':', '_');
  //       if (dateIni && dateFin && this.imeiVei) {
  //         this.vpcReportService.vpcReportTime(this.imeiVei.sn_imei_id, dateIni, dateFin)
  //           .then(data => {
  //             //$('#headTable').html(s);

  //             console.log('data : ', data)
  //             this.dataReport = [];
  //             //$('.tbodyTable').empty();
  //             this.spinner.hide();
  //             this.report = data;
  //             const dateValidate = new Date('2018-01-01 00:00:00.00');
  //             const dateValidateSum = new Date('2018-01-01 00:00:00.00');
  //             let trip = 0;
  //             let totalIn = 0;
  //             let totalOut = 0;
  //             let promTot = 0;
  //             // const quant = parseInt(data.length) - 1;
  //             const quant = parseInt(data.length);
  //             if (quant > 0) {
  //               $('.tbodyTable').empty();
  //               //$('#tbodyTable').append('<td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td>');
  //               for (let i = 0; i < data.length; i++) {
  //                 data[i].trip = trip;
  //                 data[i].plate = this.imeiVei.tracker_name;
  //                 const dateArray = new Date(data[i].startdate);
  //                 if (dateArray < dateValidate || dateArray > dateValidateSum){
  //                   var it = {};
  //                   trip = trip + 1;
  //                   data[i].trip = trip;
  //                   it["Viaje"] = trip;
  //                   it["Placa"] = data[i].plate;
  //                   it["Ruta"] = data[i].route;
  //                   it["Fecha"] = data[i].registerTime;
  //                   it["Hora inicio"] = data[i].startTime;
  //                   it["Hora fin"] = data[i].endTime;
  //                   var j=0;
  //                   var jsonObj = []; //definición objeto json
  //                   var jsonAuxObj = [];
  //                    if(data[i].controlPoints!=""){
  //                      var res= data[i].controlPoints.split(':');
  //                      console.log('puntos tamaño', res.length);
  //                      while(j<res.length){
  //                         var item = {}
  //                         item ["id"] = res[j]; //id del punto de chequeo donde paso el bus
  //                         j++;
  //                         item ["name"] = res[j]; //nombre del punto de chequeo donde paso el bus
  //                         j++;
  //                         item["d"] = res[j];//minutos antes o después del punto de chequeo donde paso el bus
  //                         j++;
  //                         jsonAuxObj.push(item);
  //                         //j++;
  //                      }
  //                      var b = false;
  //                      console.log('data object points aux',jsonAuxObj);
  //                      for(var z=0;z<this.checkingPoints.length;z++){
  //                          for(var w = 0; w < jsonAuxObj.length; w++){
  //                               if(String(jsonAuxObj[w].id) == String(this.checkingPoints[z].id)){
  //                                  var item = {};
  //                                  item ["d"] = jsonAuxObj[w].d;
  //                                  it[jsonAuxObj[w].name] = jsonAuxObj[w].d;
  //                                  jsonObj.push(item);
  //                                  b = true;
  //                                  break;
  //                               }
  //                           }
  //                           if(b==false){
  //                                var item = {};
  //                                it[this.checkingPoints[z].name] = "0";
  //                                item ["d"] = "0";
  //                                jsonObj.push(item);
  //                           }
  //                           b=false;
  //                       }
  //                    }else{
  //                      for(var z=0;z<this.checkingPoints.length;z++){
  //                        var item = {}
  //                        item ["d"] = "0";
  //                        it[this.checkingPoints[z].name] = "0";
  //                        jsonObj.push(item);
  //                      }
  //                    }

  //                   data[i].points = jsonObj;
  //                   console.log('data object points : ', data[i].points);
  //                   this.dataReport.push(data[i]);
  //                   console.log('this.dataReport : ', this.dataReport);
  //                   it["Total antes"] = data[i].totalBefore;
  //                   it["Total después"] = data[i].totalAfter;
  //                   this.dataObj.push(it);
  //                 }
  //                 dateValidateSum.setMinutes(dateValidateSum.getMinutes() + 10);
  //                 event.preventDefault();
  //                 totalIn = totalIn + parseInt(data[i]['totalInPass']);
  //                 totalOut = totalOut + parseInt(data[i]['totalOutPass']);
  //               }
  //               /*const valueValidate = parseInt(data.length)-1;
  //               console.log('valueValidate : : : ', valueValidate)
  //               this.totalAfter = data[valueValidate]['totalAfter']
  //               this.totalBefore = data[valueValidate]['totalBefore']

  //               console.log('this.totalAfter : ', this.totalAfter)
  //               console.log('this.totalBefore : ', this.totalBefore)*/
  //               console.log('object export', this.dataObj)
  //               console.log('report data', this.dataReport);
  //               this.setTable(this.dataReport)


  //               this.totalIn = totalIn;
  //               console.log('this.totalIn : ', this.totalIn)
  //               this.totalOut = totalOut;
  //               console.log('this.totalOut : ', this.totalOut)
  //               this.totalProm = Math.round((this.totalIn + this.totalOut) / 2);
  //             }else {
  //               $('.tbodyTable').empty();
  //               swal({
  //                 title: 'No existen datos para este rango de fechas',
  //                 text: '',
  //                 type: 'warning',
  //                 showCancelButton: false,
  //                 confirmButtonColor: '#3085d6',
  //                 cancelButtonColor: '#ff5370',
  //                 confirmButtonText: 'Volver',
  //                 // cancelButtonText: 'No'
  //               }).catch(swal.noop);
  //             }
  //           })
  //           .catch(error => {
  //             this.spinner.hide();
  //             // console.log('vpcReport.component.error');
  //             swal({
  //               title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
  //               text: '',
  //               type: 'error',
  //               showCancelButton: false,
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#ff5370',
  //               confirmButtonText: 'Volver',
  //               // cancelButtonText: 'No'
  //             }).catch(swal.noop);
  //           });
  //       }else {
  //         this.spinner.hide();
  //         swal({
  //           title: 'Ingresa Todos los campos solicitados',
  //           text: '',
  //           type: 'error',
  //           showCancelButton: false,
  //           confirmButtonColor: '#3085d6',
  //           cancelButtonColor: '#ff5370',
  //           confirmButtonText: 'Volver',
  //           // cancelButtonText: 'No'
  //         }).catch(swal.noop);
  //       }
  //    }else{
  //      //console.log('todos');
  //      //var dateIni = $('#dateIni').val().replace(':', '_');
  //      //var dateFin = $('#dateFin').val().replace(':', '_');
  //      if (dateIni && dateFin) {
  //        this.vpcReportService.vpcReportTimeAll(this.commonService.getUserName(), dateIni, dateFin)
  //          .then(data => {
  //            //$('#headTable').html(s);

  //            console.log('data : ', data)
  //            this.dataReport = [];
  //            //$('.tbodyTable').empty();
  //            this.spinner.hide();
  //            this.report = data;
  //            const dateValidate = new Date('2018-01-01 00:00:00.00');
  //            const dateValidateSum = new Date('2018-01-01 00:00:00.00');
  //            let trip = 0;
  //            let totalIn = 0;
  //            let totalOut = 0;
  //            let promTot = 0;
  //            // const quant = parseInt(data.length) - 1;
  //            const quant = parseInt(data.length);
  //            if (quant > 0) {
  //              for (let i = 0; i < data.length; i++) {
  //                data[i].trip = trip;
  //                //data[i].plate = this.imeiVei.tracker_name;
  //                const dateArray = new Date(data[i].startdate);
  //                if (dateArray < dateValidate || dateArray > dateValidateSum){
  //                  var it = {};
  //                  trip = trip + 1;
  //                  data[i].trip = trip;
  //                  it["Viaje"] = trip;
  //                  it["Placa"] = data[i].plate;
  //                  it["Ruta"] = data[i].route;
  //                  it["Fecha"] = data[i].registerTime;
  //                  it["Hora inicio"] = data[i].startTime;
  //                  it["Hora fin"] = data[i].endTime;
  //                  var j=0;
  //                  var jsonObj = []; //definición objeto json
  //                  var jsonAuxObj = [];
  //                   if(data[i].controlPoints!=""){
  //                     var res= data[i].controlPoints.split(':');
  //                     console.log('puntos tamaño', res.length);
  //                     while(j<res.length){
  //                        var item = {}
  //                        item ["id"] = res[j]; //id del punto de chequeo donde paso el bus
  //                        j++;
  //                        item ["name"] = res[j]; //nombre del punto de chequeo donde paso el bus
  //                        j++;
  //                        item["d"] = res[j];//minutos antes o después del punto de chequeo donde paso el bus
  //                        j++;
  //                        jsonAuxObj.push(item);
  //                        //j++;
  //                     }
  //                     var b = false;
  //                     console.log('data object points aux',jsonAuxObj);
  //                     for(var z=0;z<this.checkingPoints.length;z++){
  //                         for(var w = 0; w < jsonAuxObj.length; w++){
  //                              if(String(jsonAuxObj[w].id) == String(this.checkingPoints[z].id)){
  //                                 var item = {}
  //                                 item ["d"] = jsonAuxObj[w].d;
  //                                 it[jsonAuxObj[w].name] = jsonAuxObj[w].d;
  //                                 jsonObj.push(item);
  //                                 b = true;
  //                                 break;
  //                              }
  //                          }
  //                          if(b==false){
  //                               var item = {};
  //                               it[this.checkingPoints[z].name] = "0";
  //                               item ["d"] = "0";
  //                               jsonObj.push(item);
  //                          }
  //                          b=false;
  //                      }
  //                   }else{
  //                     for(var z=0;z<this.checkingPoints.length;z++){
  //                       var item = {};
  //                       it[this.checkingPoints[z].name] = "0";
  //                       item ["d"] = "0";
  //                       jsonObj.push(item);
  //                     }
  //                   }

  //                  data[i].points = jsonObj;
  //                  console.log('data object points : ', data[i].points);
  //                  this.dataReport.push(data[i]);
  //                  console.log('this.dataReport : ', this.dataReport)
  //                  it["Total antes"] = data[i].totalBefore;
  //                  it["Total después"] = data[i].totalAfter;
  //                  this.dataObj.push(it);
  //                }
  //                dateValidateSum.setMinutes(dateValidateSum.getMinutes() + 10);
  //                event.preventDefault();
  //                totalIn = totalIn + parseInt(data[i]['totalInPass']);
  //                totalOut = totalOut + parseInt(data[i]['totalOutPass']);
  //              }
  //              this.setTable(this.dataReport)

  //              const valueValidate = parseInt(data.length)-1;
  //              console.log('valueValidate : : : ', valueValidate)
  //              this.totalAfter = data[valueValidate]['totalAfter']
  //              this.totalBefore = data[valueValidate]['totalBefore']

  //              console.log('this.totalAfter : ', this.totalAfter)
  //              console.log('this.totalBefore : ', this.totalBefore)

  //              console.log('report data', this.dataReport);
  //              //this.getCheckingPoints(1);

  //              this.totalIn = totalIn;
  //              console.log('this.totalIn : ', this.totalIn)
  //              this.totalOut = totalOut;
  //              console.log('this.totalOut : ', this.totalOut)
  //              this.totalProm = Math.round((this.totalIn + this.totalOut) / 2);
  //            }else {
  //              $('.tbodyTable').empty();
  //              swal({
  //                title: 'No existen datos para este rango de fechas',
  //                text: '',
  //                type: 'warning',
  //                showCancelButton: false,
  //                confirmButtonColor: '#3085d6',
  //                cancelButtonColor: '#ff5370',
  //                confirmButtonText: 'Volver',
  //                // cancelButtonText: 'No'
  //              }).catch(swal.noop);
  //            }
  //          })
  //          .catch(error => {
  //            console.log(error);
  //            this.spinner.hide();
  //            // console.log('vpcReport.component.error');
  //            swal({
  //              title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
  //              text: '',
  //              type: 'error',
  //              showCancelButton: false,
  //              confirmButtonColor: '#3085d6',
  //              cancelButtonColor: '#ff5370',
  //              confirmButtonText: 'Volver',
  //              // cancelButtonText: 'No'
  //            }).catch(swal.noop);
  //          });
  //      }else {
  //        this.spinner.hide();
  //        swal({
  //          title: 'Ingresa Todos los campos solicitados',
  //          text: '',
  //          type: 'error',
  //          showCancelButton: false,
  //          confirmButtonColor: '#3085d6',
  //          cancelButtonColor: '#ff5370',
  //          confirmButtonText: 'Volver',
  //          // cancelButtonText: 'No'
  //        }).catch(swal.noop);
  //      }
  //    }
  // }



  //Método para obtener todos los puntos de chequeo por donde paso el bus según el número de viaje si se llega a necesitar
  /*getCheckingPoints(trip): void{
    for (let i = 0; i < this.dataReport.length; i++) {
        if(this.dataReport[i].trip==trip){
           this.checkingPoints = this.dataReport[i].points;
           break;
        }
    }
    console.log('checking points:',this.checkingPoints);
  }*/

  getPlates(): void {
    console.log('getPlates')
    this.spinner.show();
    this.vpcReportService.getPlates(this.commonService.getUserName()).then(response => {
      this.plates = response;
      this.plates.sort(function (a, b) {
        if (a.tracker_name > b.tracker_name) {
          return 1;
        }
        if (a.tracker_name < b.tracker_name) {
          return -1;
        }
        // a must be equal to b
        return 0;
        });
      
      for (var i in this.plates) {
        this.plates[i].tracker_name = this.plates[i].tracker_name + " - " + this.plates[i].license_plate
      }
      console.log('response : : : ', this.plates)
      this.platesBuffer = this.plates.slice(0, this.bufferSize);
      this.user_account = this.plates.user_account;
      this.imeiVei   = this.plates.sn_imei_id;
    });
    this.spinner.hide();
  }

  fetchMorePlate() {
    const len = this.platesBuffer.length;
    const more = this.plates.slice(len, this.bufferSize + len);
    this.loading1 = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading1 = false;
      this.platesBuffer = this.platesBuffer.concat(more);
    }, 200);
  }
  exportToExcel() {
    if(this.dataObj.length>0){
       this.excelService.exportAsExcelFile(this.dataObj, 'archivo_caidas');
    }else{
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }

  setTable(data, selectedPoints){
    this.displayedColumns = [
                          //"Viaje",
                          "Placa",
                          "Driver",
                          "Ruta",
                          "Fecha" ,
                          "Hora inicio" ,
                          "Hora fin"  ,
                          "Tipo Hora",
                          ];
    // Agrega las columnas correpondientes a los puntos de control seleccionados
    console.log(this.controlPoints)
    for(var i in this.controlPoints){
      if(selectedPoints.includes(this.controlPoints[i].id))
      this.displayedColumns.push(this.controlPoints[i].name)
    }                          
    this.displayedColumns.push("Total Antes")
    this.displayedColumns.push("Total Despues")
    
    this.dataReport2 = new MatTableDataSource(data);
    this.dataReport2.sort = this.sort;
    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente

    setTimeout(() => 
    {
      try {
        this.dataReport2.paginator = this.paginator;
        this.dataReport2.paginator._intl.itemsPerPageLabel = "Filas por Página:"
      } catch (error) {
      }
      $(".mat-paginator-page-size").css("display", "none")
    },
    500);
  }

  setExcelData(data){
    this.dataObj = []
    for(var i in data){
      let item = {}
      item["Placa"] = data[i].Plate
      item["Conductor"] = data[i].Driver
      item["Ruta"] = data[i].RouteName
      item["Fecha" ] = data[i].StartDate
      item["Hora inicio" ] = data[i].StartTime
      item["Hora fin" ] = data[i].EndingDate
      item["Tipo Hora"] = data[i].TimeType

      // Agrega las columnas correpondientes a los puntos de control seleccionados
      for(var j in this.controlPoints){
        item[this.controlPoints[j].name] = data[i][this.controlPoints[j].name]
      }                          
      item["Total Antes"] = data[i].totalBefore
      item["Total Despues"] = data[i].totalAfter

      this.dataObj.push(item)
    }
    console.log(this.dataObj)
    
  }

  applyFilter(filterValue: string) {
    this.dataReport2.filter = filterValue.trim().toLowerCase();
    if (this.dataReport2.paginator) {
      this.dataReport2.paginator.firstPage();
    }
  }

  sortData(e){
    console.log(e)
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/time-report/time-report.component.ts